import classNames from 'classnames'
import { NumberedMilestone } from './progression-milestone'

export function ProgressionNavItem({
  milestone,
  signalMilestone,
  completedMilestones,
  onMilestoneClick
}: {
  milestone: NumberedMilestone
  signalMilestone: (id: string) => void
  completedMilestones: Set<string>
  onMilestoneClick: (id: string) => void
}) {
  return (
    <li
      className={classNames(
        'poe-milestone-item',
        completedMilestones.has(milestone.id) && 'poe-milestone-item-complete',
        milestone.visible === false && 'poe-milestone-item-hidden'
      )}
      onClick={() => {
        onMilestoneClick(milestone.id)
      }}
      onMouseEnter={() => {
        signalMilestone(milestone.id)
      }}>
      <span>
        {milestone.index}. {milestone.title}
      </span>
    </li>
  )
}
